// src/NotificationInit.js
import ApiRequests from "./ApiRequests";

export default{
    async getNotifications(){
        return ApiRequests.apiRequest('get','portal/getNotifications',null).then((data)=>{
            return data;
        })
    },
    async upadateNotification(notification_pk){
        return ApiRequests.apiRequest('post','portal/updateNotificationStatus',null ,{
            notification_pk: notification_pk
          })
       

    }
    
}
 
